import React, {useEffect} from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import "./style.css";
import {CoraRedirection} from "../../../utils/HomeApis";
import {useDispatch, useSelector} from "react-redux";
import SnackbarComp from "../../containers/Snackbar/SnackbarComp";


const ErrorFallback = ({error}) => {
    const dispatch = useDispatch();
    const homeData = useSelector((state) => state.Home);

    useEffect(() => {

        if (!homeData?.cora_id) {
            return;
        }
        const redirectionTimeoutId = setTimeout(() => {
                return CoraRedirection({status: "Taxable", homeData, dispatch});
            }, 1000);
        return () => clearTimeout(redirectionTimeoutId);
    }, [error]);

    return (
        <>
            <div
                role="alert"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '90vh'
                }}
            >
                <div>
                    <ErrorIcon style={{fontSize: '90px', color: 'gray'}}/>
                </div>
                <h1>Oops! Something went wrong</h1>
                <div style={{color: 'red', margin: '0 20%', 'text-align': 'center'}}>
                    <span style={{fontSize: '18px'}}>Error Details: </span>{' '}
                    {error || error?.message}
                </div>
            </div>
            <SnackbarComp/>
        </>
    );
};
export default ErrorFallback;
